"use client";

import React from "react";
import type { AccordionItemContextType } from "./types";

const AccordionItemContext = React.createContext<AccordionItemContextType>({
  isOpen: false,
  setIsOpen: () => {},
});

export default AccordionItemContext;
